export enum TestSwitchCases {
  instruction = 'instruction',
  test = 'test',
  summary = 'summary',
  notAlone = 'notAlone',
  loadingView = 'loadingView',
}
